<div class="container">
  <div class="material-icons {{icon_class}} icon">{{icon}}</div>
  <div class="message_container">
    <span>{{message}}</span>
  </div>
</div>
